import React from 'react';
import { Button, message, Popconfirm } from 'antd';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { useTranslation } from 'react-i18next';

function DeleteLeagueLocation(props) {
    const [messageApi, contextHolder] = message.useMessage();
    const { t } = useTranslation();

    async function confirm(event) {
        event.preventDefault();
        messageApi.success('Cancelling Location!')
        const response = await fetch(api.leagues().removeLocation(props.leagueId).href, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(props.location) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())
        .then((data) => window.location.reload(false))
        .catch((error) => console.error(error))
    }

    return (
        <div>
            {contextHolder}
            <Popconfirm
                title="Delete location"
                description="Are you sure to delete this location?"
                onConfirm={confirm}
                okText="Yes"
                cancelText="No"
            >
                <Button danger>{t('common.delete')}</Button>
            </Popconfirm>
        </div>
    );
}

export default DeleteLeagueLocation;
